<script setup>


import {ref, onMounted, computed, watch} from 'vue';
import { useRoute, useRouter } from 'vue-router';
import Ticker from '@/components/App/ticker.vue';
import HeaderDefault from '@/components/App/header-default/header-default.vue';
import RibbonControls from '@/components/App/ribbon-controls.vue';
import UserAddresses from '@/views/App/Account/components/user-addresses.vue';
import UserOrders from '@/views/App/Account/components/user-orders.vue';
import FooterDefault from '@/components/App/footer/footer.vue';

import { useCommonComposable } from '@/composables/commonComposable.js';
const { user, getUser } = useCommonComposable();

const route = useRoute();
const router = useRouter();

// Данные компонента
const pages = ref([
    {
        name: 'orders',
        header: 'Заказы'
    },
    {
        name: 'settings',
        header: 'Настройки'
    }
]);

const activePage = ref('');

function setActivePage(newValue) {
    activePage.value = newValue;
}

function exitAccount() {
    document.cookie = 'authToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
    router.push({ path: '/' });
}

// Хуки жизненного цикла
onMounted(async () => {
    await getUser();

    if (route.name) {
        activePage.value = route.name;
    }
});

watch(
    () => route.name,
    (newName) => {
        activePage.value = newName;
    },
    { immediate: true }
);

defineExpose({
    setActivePage,
    getUser
})
</script>

<template>
    <div class="silver-background">
        <ticker></ticker>
        <header-default></header-default>
        <div class="container page column-page">
            <div class="row">
                <div class="col-12 head">
                    <ribbon-controls :activePage="activePage" :pages="pages" @changeActivePage="setActivePage"></ribbon-controls>
                    <p class="exit" @click="exitAccount">Выйти из аккаунта</p>
                </div>
                <user-orders v-if="activePage === 'orders' && user && user.length > 0" :user="user"></user-orders>
                <div class="col-12 settings-block" v-if="activePage === 'settings' && user && user.length > 0">
                    <div class="user-info-block" v-if="user">
                        <div class="user-items-row">
                            <div class="user-item">
                                <div class="header-item"><span>Имя</span></div>
                                <div class="value-item"><span>{{ user[0]["Имя"] }}</span></div>
                            </div>
                            <div class="user-item">
                                <div class="header-item"><span>Фамилия</span></div>
                                <div class="value-item"><span>{{ user[0]["Фамилия"] }}</span></div>
                            </div>
                        </div>
                        <div class="user-item">
                            <div class="header-item"><span>Email</span></div>
                            <div class="value-item"><span>{{ user[0]["email"] }}</span></div>
                        </div>
                        <div class="user-item">
                            <div class="header-item"><span>Номер телефона</span></div>
                            <div class="value-item"><span>{{ user[0]["Номер"] }}</span></div>
                        </div>
                    </div>
                    <user-addresses v-if="user" :user="user"></user-addresses>
                </div>
            </div>
        </div>
    </div>
    <footer-default></footer-default>
</template>

<style scoped lang="scss">
@use '~@/assets/styles/vars' as *;

    .row {
        gap: 15px
    }

    .user-info-block {
        background: $white;
        border-radius: 10px;
        padding: 2%;
        display: flex;
        flex-direction: column;
        gap: 15px
    }

    .user-items-row {
        display: flex;
        gap: 20px
    }

    .user-item {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 10px
    }

    .header-item {
        background: $silver;
        padding: 10px 15px;
        box-sizing: border-box;
        border-radius: 10px;
        transition: $transition;
        cursor: pointer;
    }

    .header-item:hover {
        background: $silver-hover;
    }

    .user-item span {
        font-size: 16px;
        font-weight: 400;
    }

    .header-item span {
        font-size: 14px;
        font-weight: 500;
    }

    .settings-block {
        display: flex;
        flex-direction: column;
        gap: 30px
    }

    .head {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }

    p.exit {
        color: $hard-gray;
        font-size: 12px;
        text-decoration: underline;
        cursor: pointer;
        transition: $transition;
    }

    p.exit:hover {
        color: $black;
    }

    @media screen and (max-width: 750px) {
        .user-info-block {
            padding: 10px;
        }

        .header-item {
            padding: 8px 13px;
        }

        .user-items-row {
            flex-direction: column;
            gap: 10px;
        }

        .user-info-block {
            gap: 10px
        }

        .user-item span {
            font-size: 14px;
        }

        .header-item span {
            font-size: 13px;
        }
    }
</style>